import axiosInstance from "shared/services";
import {
  ISoftwareEmployeeResponse,
  ISoftwareEmployeeCreateResponse,
} from "modules/software-employee/types";

const uri = "software-employees";

export const all = async (): Promise<ISoftwareEmployeeResponse> =>
  axiosInstance.get(uri).then();

export const create = async (): Promise<ISoftwareEmployeeCreateResponse> =>
  axiosInstance.post(uri).then();
